import { getFoerderregimeLabel } from "../../../../components/Paragraph6/utils/getFoerderregimeLabel";
import { getVeraeusserungsformLabel } from "../../../../components/PeriodBasedComponents/MarketingTypeTable/MarketingTypeTable.constants";
import { FoerderRegime, Veraeusserungsform } from "../../../../types/api.types";
import { getNeedsGebotstermin } from "../../../../utils/getNeedsGebotstermin";
import { getNeedsJahrDesGebotstermins } from "../../../../utils/getNeedsJahrDesGebotstermins";
import type {
  ExpressOnboardingGenerator,
  ExpressOnboardingGeneratorsTableErrors
} from "../../ExpressOnboarding.types";

const EEG_FOERDERREGIMES = [
  FoerderRegime.eeg_ausschreibung,
  FoerderRegime.eeg_ohne_ausschreibung,
  FoerderRegime.eeg_fixe_einspeiseverguetung,
  FoerderRegime.eeg_innovationsausschreibung_fixe_marktpraemie,
  FoerderRegime.eeg_innovationsausschreibung_gleitende_marktpraemie
];

// Mirrors VeraeusserungsformEnum.allowed_foerderregimes in the backend.
const ALLOWED_FOERDERREGIMES: Record<Veraeusserungsform, FoerderRegime[]> = {
  [Veraeusserungsform.subsidized_direct_marketing]: EEG_FOERDERREGIMES,
  [Veraeusserungsform.feste_einspeiseverguetung]: [
    FoerderRegime.eeg_fixe_einspeiseverguetung
  ],
  [Veraeusserungsform.other_direct_marketing]: [
    ...EEG_FOERDERREGIMES,
    FoerderRegime.keine_foerderung_in_anspruch_genommen,
    FoerderRegime.foerderung_ausgelaufen
  ]
};

function getExpressOnboardingEegSave(
  generator: ExpressOnboardingGenerator,
  draft: Partial<ExpressOnboardingGenerator> | undefined,
  change: Partial<ExpressOnboardingGenerator>
) {
  const patch = { ...draft, ...change };
  const current = { ...generator, ...patch };
  const errors: ExpressOnboardingGeneratorsTableErrors[number] = {};
  const { foerderregime, veraeusserungsform } = current;

  if (
    foerderregime &&
    "foerderregime" in patch &&
    !getNeedsJahrDesGebotstermins(foerderregime)
  ) {
    patch.jahr_des_gebotstermins = null;
    patch.gebotstermin = null;
  } else if (
    patch.jahr_des_gebotstermins &&
    !getNeedsGebotstermin(patch.jahr_des_gebotstermins)
  ) {
    patch.gebotstermin = null;
  }

  const { jahr_des_gebotstermins, gebotstermin } = { ...current, ...patch };
  if (foerderregime && getNeedsJahrDesGebotstermins(foerderregime)) {
    if (!jahr_des_gebotstermins) {
      errors.jahr_des_gebotstermins =
        "Für das gewählte Förderregime muss das Jahr des Gebotstermins angegeben werden.";
    } else if (getNeedsGebotstermin(jahr_des_gebotstermins) && !gebotstermin) {
      errors.gebotstermin =
        "Für das Jahr des Gebotstermins muss ein konkreter Gebotstermin angegeben werden.";
    }
  }

  if (veraeusserungsform) {
    if (!foerderregime) {
      errors.foerderregime =
        "Bevor Veräußerungsformen angegeben werden können, muss das Förderregime für den Erzeuger gesetzt werden.";
    } else if (
      !ALLOWED_FOERDERREGIMES[veraeusserungsform].includes(foerderregime)
    ) {
      errors.veraeusserungsform =
        `Das Förderregime „${getFoerderregimeLabel(foerderregime)}“ des Erzeugers ist nicht ` +
        `mit der Veräußerungsform „${getVeraeusserungsformLabel(veraeusserungsform)}“ vereinbar.`;
    }
  }

  return { patch, errors };
}

export { getExpressOnboardingEegSave };
